import { getApi } from './api_instance'

export const fetchDepositBankDetails = async dispatch => {
  try {
    const { data } = await getApi({
      apiUrl: `/api/bankAccount/admin/primary-account`,
      sendToken: true,
      dispatch
    })
    return data
  } catch (error) {
    throw error
  }
}
